import React, { useEffect, useState } from 'react';
import { useField } from 'formik';
import { Typography, MenuItem, Select, CircularProgress } from '@mui/material';
import Grid from '@mui/material/Grid';
import { FormControl} from '@mui/base/FormControl';
import { Input} from '@mui/base/Input';
import Box from '@mui/material/Box';
import Hidden from '@mui/material/Hidden';
import SharePointService from '../../services/sharepoint.service';

import './forms.css';

const Kontaktdaten = () => {
    const [nameField, nameMeta] = useField('name');
    const [emailField, emailMeta] = useField('email');
    const [telField, telMeta] = useField('tel');
    const [whgField, whgMeta, whgHelpers] = useField('whg');
    const [addressField, addressMeta] = useField('address');
    const [projectField, projectMeta, projectHelpers] = useField('project');

    const [wohnungen, setWohnungen] = useState([]);
    const [projekte, setProjekte] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadDropdownData = async () => {
            try {
                const data = await SharePointService.getWohnungenForCustomer();
                console.log(data)
                setWohnungen(data.wohnungen || []);
                setProjekte(data.projekte || []);
            } catch (error) {
                console.error('Fehler beim Laden der Dropdown-Daten:', error);
            } finally {
                setLoading(false);
            }
        };
        loadDropdownData();
    }, []);

    return (
        <div>
            <h2>Kontaktinformationen</h2>
            <Grid container spacing={2} my={2}>
                <Grid item xs={12} md={8}>
                    <Hidden mdUp>
                        <Grid item xs={12} md={4} pb={5}>
                            <Box sx={{ backgroundColor: '#F0F2F5', p: 4 }}>
                                <Typography variant="h5" sx={{color: '#3a8787', pb: 1}}>Wichtig!</Typography>
                                <Typography variant="p">Vergessen Sie nicht, Ihre Telefonnummer und E-Mail-Adresse anzugeben. Zwingend notwendig, damit der Handwerker Sie erreichen kann!</Typography>
                            </Box>
                        </Grid>
                    </Hidden>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={10}>
                            <FormControl className='wb-input-wrapper' {...nameField} required type="text" error={nameMeta.touched && nameMeta.error ? true : false} >
                                <label>Name</label>
                                <Input name="name"  />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={10}>
                            <FormControl className='wb-input-wrapper' {...addressField} required error={addressMeta.touched && addressMeta.error ? true : false} >
                                <label>Adresse</label>
                                <Input name="address" type="text"/>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={5}>
                            <FormControl className='wb-input-wrapper' {...emailField} required  error={emailMeta.touched && emailMeta.error ? true : false} >
                                <label>E-Mail</label>
                                <Input name="email" type="text"/>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={5}>
                            <FormControl className='wb-input-wrapper' {...telField} required error={telMeta.touched && telMeta.error ? true : false} >
                                <label>Telefon</label>
                                <Input name="tel" type="tel"/>
                                {telMeta.error && (
                                    <Typography sx={{ color: 'red', fontSize: '0.875rem', mt: 0.5 }}>
                                        {telMeta.error}
                                    </Typography>
                                )}
                            </FormControl>
                        </Grid>
                        
                        {/* Wohnungsnummer Dropdown */}
                        <Grid item xs={12} md={5}>
                            <FormControl 
                                className='wb-input-wrapper' 
                                required 
                                error={whgMeta.touched && whgMeta.error ? true : false}
                            >
                                <label>Wohnungsnummer</label>
                                {loading ? (
                                    <Box sx={{ display: 'flex', alignItems: 'center', p: 2 }}>
                                        <CircularProgress size={20} />
                                    </Box>
                                ) : (
                                    <Select
                                        className="wb-select"
                                        value={whgField.value}
                                        onChange={(e) => whgHelpers.setValue(String(e.target.value))} // ← String() hinzufügen
                                        name="whg"
                                        displayEmpty
                                        >
                                        <MenuItem value="" disabled>Bitte wählen</MenuItem>
                                        {wohnungen.map(w => (
                                            <MenuItem key={w.id} value={String(w.id)}>  {/* ← String() hinzufügen */}
                                            {w.title}
                                            </MenuItem>
                                        ))}
                                        </Select>
                                )}
                                {whgMeta.touched && whgMeta.error && (
                                    <Typography sx={{ color: 'red', fontSize: '0.875rem', mt: 0.5 }}>
                                        {whgMeta.error}
                                    </Typography>
                                )}
                            </FormControl>
                        </Grid>

                        {/* Bauvorhaben Dropdown */}
                        <Grid item xs={12} md={5}>
                            <FormControl 
                                className='wb-input-wrapper' 
                                required 
                                error={projectMeta.touched && projectMeta.error ? true : false}
                            >
                                <label>Bauvorhaben</label>
                                {loading ? (
                                    <Box sx={{ display: 'flex', alignItems: 'center', p: 2 }}>
                                        <CircularProgress size={20} />
                                    </Box>
                                ) : (
                                    <Select
                                        className="wb-select"
                                        value={projectField.value}
                                        onChange={(e) => projectHelpers.setValue(String(e.target.value))}  // ← String()
                                        name="project"
                                        displayEmpty
                                        >
                                        <MenuItem value="" disabled>Bitte wählen</MenuItem>
                                        {projekte.map(p => (
                                            <MenuItem key={p.id} value={String(p.id)}>  {/* ← String() */}
                                            {p.title}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                )}
                                {projectMeta.touched && projectMeta.error && (
                                    <Typography sx={{ color: 'red', fontSize: '0.875rem', mt: 0.5 }}>
                                        {projectMeta.error}
                                    </Typography>
                                )}
                            </FormControl>
                        </Grid>
                    </Grid>
                </Grid>
                <Hidden mdDown>
                    <Grid item xs={12} md={4}>
                        <Box sx={{ backgroundColor: '#F0F2F5', p: 4 }}>
                            <Typography variant="h5" sx={{color: '#3a8787', pb: 1}}>Wichtig!</Typography>
                            <Typography variant="p">Vergessen Sie nicht, Ihre Telefonnummer und E-Mail-Adresse anzugeben. Zwingend notwendig, damit der Handwerker Sie erreichen kann!</Typography>
                        </Box>
                    </Grid>
                </Hidden>
            </Grid>
        </div>
    );
};

export default Kontaktdaten;